import { render } from "./TicketComponentKDS.vue?vue&type=template&id=9651a990&scoped=true"
import script from "./TicketComponentKDS.vue?vue&type=script&lang=js"
export * from "./TicketComponentKDS.vue?vue&type=script&lang=js"

import "./TicketComponentKDS.vue?vue&type=style&index=0&id=9651a990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9651a990"]])

export default __exports__